<script setup>
  import { ref, computed, watchEffect } from 'vue';
  import { useSpotStore } from "@/stores/SpotStore";
  import useConfigurationGlobals from '@/composables/useConfigurationGlobals';

  const { $TEMPESTPROVIDERS, $AIBPROVIDERS } = useConfigurationGlobals();

  const spotStore = useSpotStore();

  const caricoosStationIds = [48649, 48687, 48688, 48685, 48650, 48686, 160340, 630468, 602927, 602928, 598460, 151997, 48691, 48694, 48692];

  const sourceMessage = ref(null);
  const sourceMessagePosition = ref('bottom');

  if (caricoosStationIds.indexOf(spotStore.spotId) > -1) {
    sourceMessage.value = 'Funded by';
    sourceMessagePosition.value = 'top';
  } else {
    sourceMessage.value = spotStore.defaultStation.source_message;
  }

  const sourceLogo = computed(() => {
    const provider = spotStore.defaultStation.provider;
    const message = spotStore.defaultStation.source_message

    if (caricoosStationIds.indexOf(spotStore.spotId) > -1) {
      return {
        websiteLink: 'http://caricoos.org/',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-caricoos.png',
        alt: 'Caricoos Logo'
      }
    }

    if (message && message.indexOf('nderground') > -1) {
      return {
        websiteLink: 'https://www.wunderground.com/?apiref=57d4c49097e5b689',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-wunder.png',
        alt: 'Wunderground.com logo'
      }
    }

    if (provider === 1) {
      if (message && message.indexOf('Endless Windz') > -1) {
        return {
          websiteLink: 'http://endlesswindz.com/',
          imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-endless-windz.jpg',
          alt: 'Endless Windz Logo'
        }
      }

      return {
          websiteLink: 'https://www.weatherflow.com/',
          imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-weatherflow-networks.png',
          alt: 'WeatherFlow Network logo'
      }
    }

    if (provider === 335) {
      return {
        websiteLink: 'http://www.iweathar.co.za',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-iweather.jpg',
        alt: 'iWeather Logo'
      }
    }

    if (provider === 338) {
      return {
        websiteLink: 'http://recon.sccf.org',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-sccf.png',
        alt: 'SCCF Recon Logo'
      }
    }

    if (provider === 385) {
      return {
        websiteLink: 'http://thewindop.com/',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-windop.jpg',
        alt: 'The WindOp.com Logo'
      }
    }

    if ($AIBPROVIDERS.indexOf(provider) > -1) {
      return {
        websiteLink: 'http://www.weatherflow.com/',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-nearcast.svg',
        alt: 'WeatherFlow Network logo'
      }
    }    

    if ($TEMPESTPROVIDERS.indexOf(provider) > -1 || spotStore.defaultStation.is_nc_wind) {
      return {
        websiteLink: 'https://got.wf/tempest',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-tempest.svg',
        alt: 'Tempest Network logo'
      }
    }

    if (message && message.indexOf('KiteProvo') > -1) {
      return {
        websiteLink: 'http://kiteprovo.com',
        imageSource: 'https://cdn-consumer.weatherflow.com/images/station-provider/courtesy-kite_provo.jpg',
        alt: 'KiteProvo.com logo'
      }
    }

    return {
      websiteLink: false,
      imageSource: false
    }
  })

  const showSourceBlock = computed(() => spotStore.defaultStation.source_message || sourceLogo.value.attributionText);

  watchEffect(() => sourceMessage.value = spotStore.defaultStation.source_message);
</script>

<template>
  <div v-if="showSourceBlock" class="jwx-current-conditions-source">
    <a
      v-if="sourceLogo.websiteLink"
      :href="sourceLogo.websiteLink" 
      class="jwx-current-conditions-source__link" 
      target="_blank"
    >
      <img :src="sourceLogo.imageSource" :alt="sourceLogo.alt" class="jwx-current-conditions-source__logo">
    </a>
    <p
      v-html="sourceMessage"
      class="jwx-current-conditions-source__message"
      :data-position="sourceMessagePosition"
    ></p>
  </div>
</template>